import type { TemplateOnlyComponent } from '@ember/component/template-only';

export interface Signature {
  Args: {
    class?: string;
  };
  Element: SVGElement;
}

const WrZapArrowDownIconComponent: TemplateOnlyComponent<Signature> = <template>
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    class={{@class}}
    ...attributes
  >
    <path
      d='M15.0006 12.4688C15.0004 12.4688 15.0007 12.4688 15.0006 12.4688H9.61602C9.22942 12.4688 8.91602 12.1554 8.91602 11.7688C8.91602 11.3822 9.22942 11.0688 9.61602 11.0688H13.3101L8.48667 6.24817C8.34186 6.10345 8.09782 6.14309 8.00627 6.3262L7.09323 8.15227C6.57421 9.1903 5.19066 9.41461 4.37027 8.59373L0.505659 4.72681C0.232373 4.45336 0.232506 4.01015 0.505954 3.73686C0.779403 3.46357 1.22262 3.46371 1.4959 3.73716L5.36051 7.60407C5.50529 7.74893 5.74944 7.70935 5.84104 7.52617L6.75407 5.7001C7.2729 4.66244 8.65575 4.43783 9.47633 5.25794L14.301 10.0798V6.38387C14.301 5.99727 14.6144 5.68387 15.001 5.68387C15.3876 5.68387 15.701 5.99727 15.701 6.38387V11.7688C15.701 12.1554 15.3872 12.4688 15.0006 12.4688Z'
      fill='currentColor'
    />
  </svg>
</template>;

export default WrZapArrowDownIconComponent;
